function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fdddbc52-61b9-46f1-8010-104c3b111832{fill:none;stroke:#f65e5c;stroke-width:12px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bc710127-5f56-47fe-b3e7-98ed22fecbfd",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "f32b40fa-e5f8-41e4-b4e9-175023d69668",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "fdddbc52-61b9-46f1-8010-104c3b111832",
  d: "M6,127.42C6,51.62,90.2,6.82,90.2,6.82s84.2,46.4,84.2,120.6a84.2,84.2,0,0,1-168.4,0Z"
})));

var SvgLogoIcon5 = function SvgLogoIcon5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180.4 217.62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (5).142a62df.svg";
export { ForwardRef as ReactComponent };